/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

// Component imports
import { Button, List, Modal, Space, Typography } from 'antd';
import { capitalize } from '../../utils/string/capitalize';

const BulkActionsModal = ({
  title='',
  action='',
  entityCount=0,
  data=[],
  isModalOpen=false,
  onModalClose=() => {},
  onModalConfirm=() => {},
  onShowMore=() => {},
  displayProperty='',
  loader=false
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={`${capitalize(action)} ${title}`}
      open={isModalOpen}
      onCancel={onModalClose}
      onOk={onModalClose}
      centered
      className={entityCount > 10 ? 'scrollable-modal' : null}
      footer={[
        <Button
          onClick={onModalClose}
          className="float-left"
        >
          {t('Cancel')}
        </Button>,
        <Button
          onClick={onModalConfirm}
          loading={loader}
          type="primary"
          danger
        >
          { capitalize(action) }
        </Button>
      ]}
    >
      <Typography.Text>
        {
        `${t(`Are you sure you want to ${action.toLowerCase()}`)} ${data.length} ${data.length < 2 ? t('item') : t('items')}?`
        }
      </Typography.Text>
      <List
        className="mt-4"
        dataSource={data.slice(0, entityCount)}
        renderItem={(item) => (
          <List.Item key={item.id || uuidv4()}>
            <Space size={20}>
              {
                // displayProperty is a string or an array (could be like [name, currentLanguage]] indicating name[currentLanguage])
                // or [name, currentLanguage, label] indicating name[currentLanguage].label
                Array.isArray(displayProperty) ? displayProperty.reduce((acc, curr) => {
                  if (typeof acc === 'object') {
                    return acc[curr];
                  }
                  return acc;
                }, item) : item[displayProperty] || item.displayName
              }
            </Space>
          </List.Item>
        )}
      />
      {
        data.length > entityCount ? (
          <Button
            className="mt-3"
            type="link"
            onClick={() => onShowMore(entityCount + 5)}
          >
            {t('Show more')} ...
          </Button>
        ) : null
      }
    </Modal>
  );
};

BulkActionsModal.propTypes = {
  title: PropTypes.string,
  action: PropTypes.string,
  entityCount: PropTypes.number,
  isModalOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalConfirm: PropTypes.func,
  loader: PropTypes.bool,
  data: PropTypes.array,
  onShowMore: PropTypes.func,
  displayProperty: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ])
};

export default BulkActionsModal;
